export default "__VITE_ASSET__BGLDCkuL__"